// Mock data for Tri-City Internists

export const providers = [
  {
    id: 1,
    name: "Muhammad Asim Khan, MD",
    title: "CEO and Medical Director",
    credentials: "Board Certified Internal Medicine",
    image: "/team/asim-khan.jpg",
    type: "ceo",
    bio: "Established in 2009, Tri-City Internists is led by a Board-Certified Internal Medicine physician with a dedicated focus on geriatric care. With extensive experience caring for older adults across every stage of health, the practice is committed to delivering compassionate, comprehensive, and personalized medical care. The physician currently serves as Medical Director for multiple skilled nursing and rehabilitation centers, including Avista Nursing Home and Rehab, Saginaw Senior Care Rehab, Adira Nursing and Rehab, Optalis St. Francis Nursing Home and Rehab in Saginaw, and Huron Woods Nursing Home and Rehab in Bay City, Michigan. In addition, they are the Medical Director of Valley Home Care and Hospice, ensuring continuity of care both in facilities and at home. Patients can trust they are receiving expert care guided by years of leadership, experience, and a genuine commitment to their well-being."
  },
  {
    id: 2,
    name: "Sadia Khan, MD",
    title: "Board-Certified Internal Medicine Specialist",
    credentials: "MD, Internal Medicine",
    image: "https://customer-assets.emergentagent.com/job_doctorsite-2/artifacts/6poamp2b_4E066D41-5DD6-4417-8C0C-66D63C820D84.png",
    type: "physician",
    imagePosition: "center 15%",
    customHeight: "h-96"
  },
  {
    id: 3,
    name: "Ayesha Khan, MD",
    title: "Medical Director, Select Specialty Hospital, Saginaw MI",
    credentials: "Board Certified Internal Medicine Specialist",
    image: "https://customer-assets.emergentagent.com/job_internal-health/artifacts/uru924jw_ayesha%20khan%20md.jpeg",
    type: "collaborating"
  },
  {
    id: 4,
    name: "Muhammad Umar Khan, MD, FACP",
    title: "Associate Professor of Medicine, Central Michigan University | Section Chief Medicine Dept, Covenant Hospital, Saginaw MI",
    credentials: "Board Certified Internal Medicine and Infectious Diseases",
    image: "https://customer-assets.emergentagent.com/job_doctorsite-2/artifacts/ypvkst5c_muhammad%20umar%20khan%20md.JPG",
    type: "collaborating",
    imagePosition: "center 5%",
    customHeight: "h-[450px]"
  },
  {
    id: 5,
    name: "Madison Robbins, NP",
    title: "Certified Family Nurse Practitioner",
    credentials: "NP, Family Medicine",
    image: "https://customer-assets.emergentagent.com/job_doctorsite-2/artifacts/4ad7h06s_image000000.jpeg",
    type: "nurse_practitioner",
    imagePosition: "center 25%",
    customHeight: "h-96"
  },
  {
    id: 6,
    name: "Denisha DeLeon, NP",
    title: "Certified Family Nurse Practitioner",
    credentials: "NP, Family Medicine",
    image: "https://customer-assets.emergentagent.com/job_internal-health/artifacts/3mpz5mpl_Deneisha%20Deleon%20Np.jpeg",
    type: "nurse_practitioner"
  },
  {
    id: 7,
    name: "Traci Bliss",
    title: "Nurse Care Manager",
    credentials: "Care Coordination & Patient Management",
    image: "https://customer-assets.emergentagent.com/job_doctorsite-2/artifacts/8lcj6ei4_image000000.jpeg",
    type: "care_manager",
    imagePosition: "center 20%",
    customHeight: "h-96"
  },
  {
    id: 8,
    name: "Amanda Whittaker",
    title: "Office Manager",
    credentials: "Practice Administration & Patient Services",
    image: "https://customer-assets.emergentagent.com/job_internal-health/artifacts/u8k46bui_Amanda%20Whittaker%20.jpeg",
    type: "office_manager",
    imagePosition: "center 10%",
    customHeight: "h-96"
  },
  {
    id: 9,
    name: "Maureen Jerry, RN",
    title: "Office Manager, Frankenmuth Office",
    credentials: "Registered Nurse & Practice Administration",
    image: "https://customer-assets.emergentagent.com/job_doctorsite-2/artifacts/2rc6rpvq_451147590261842177.heic",
    type: "office_manager",
    imagePosition: "center 20%",
    customHeight: "h-96"
  },
  {
    id: 10,
    name: "Tiera Williams, CMA",
    title: "Certified Medical Assistant",
    credentials: "Patient Care & Clinical Support",
    image: "https://customer-assets.emergentagent.com/job_doctorsite-2/artifacts/jjdvdxgp_23548902579587819.png",
    type: "care_manager",
    imagePosition: "center 15%",
    customHeight: "h-96"
  },
  {
    id: 11,
    name: "Daysia Gallardo",
    title: "Medical Assistant",
    credentials: "Patient Care & Clinical Support",
    image: "https://customer-assets.emergentagent.com/job_doctorsite-2/artifacts/2m4dnrm1_5973911774860100343.png",
    type: "care_manager",
    imagePosition: "center 30%",
    customHeight: "h-[420px]"
  },
  {
    id: 12,
    name: "Brionna Jenkins",
    title: "Medical Assistant",
    credentials: "Patient Care & Clinical Support",
    image: "https://customer-assets.emergentagent.com/job_doctorsite-2/artifacts/8txvlzdb_3615151330996031659.png",
    type: "care_manager",
    imagePosition: "center 15%",
    customHeight: "h-96"
  }
];

export const services = [
  {
    id: 1,
    name: "Hypertension Management",
    description: "Comprehensive blood pressure monitoring and treatment plans to reduce cardiovascular risk.",
    icon: "Activity"
  },
  {
    id: 2,
    name: "Diabetes Care",
    description: "Expert management of Type 1 and Type 2 diabetes with personalized treatment approaches.",
    icon: "Droplet"
  },
  {
    id: 3,
    name: "Obesity & Weight Management",
    description: "Evidence-based weight loss programs and nutritional counseling for better health outcomes.",
    icon: "Scale"
  },
  {
    id: 4,
    name: "Depression & Mental Health",
    description: "Compassionate mental health support and treatment for depression and anxiety.",
    icon: "Heart"
  },
  {
    id: 5,
    name: "Preventive Medicine",
    description: "Proactive health screenings and preventive care to maintain optimal wellness.",
    icon: "Shield"
  },
  {
    id: 6,
    name: "Annual Physicals",
    description: "Comprehensive health examinations and routine screenings for early detection.",
    icon: "Stethoscope"
  }
];

export const locations = [
  {
    id: 1,
    name: "Saginaw Office",
    address: "912 South Washington, Suite B",
    city: "Saginaw",
    state: "MI",
    zip: "48601",
    phone: "(989) 791-4100",
    email: "saginawvalleymedical@yahoo.com",
    image: "https://customer-assets.emergentagent.com/job_internal-health/artifacts/zvssq9n9_912%20s%20whagngton%20ave%20saginaw%20.jpg",
    isPrimary: true
  },
  {
    id: 2,
    name: "Frankenmuth Office",
    address: "526 W. Genesee Rd., Suite 3",
    city: "Frankenmuth",
    state: "MI",
    zip: "48734",
    phone: "(989) 480-3470",
    fax: "(989) 480-3451",
    email: "saginawvalleymedical@yahoo.com",
    image: "https://customer-assets.emergentagent.com/job_internal-health/artifacts/2g5cucr6_526%20w%20genesse%20frankenmuth%20mi.PNG",
    isPrimary: false
  }
];

export const resources = [
  {
    id: 1,
    title: "Managing High Blood Pressure",
    category: "Cardiovascular Health",
    description: "Learn about lifestyle modifications and treatment options for hypertension.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Diabetes Self-Care Guide",
    category: "Diabetes Management",
    description: "Essential tips for monitoring blood sugar and maintaining a healthy lifestyle.",
    icon: "BookOpen"
  },
  {
    id: 3,
    title: "Preventive Health Screenings",
    category: "Preventive Care",
    description: "Understand which health screenings you need and when.",
    icon: "ClipboardCheck"
  },
  {
    id: 4,
    title: "Mental Wellness Tips",
    category: "Mental Health",
    description: "Strategies for managing stress, anxiety, and maintaining emotional well-being.",
    icon: "Brain"
  }
];
